import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router';
import { ProtectedRoute } from './features/auth/components/ProtectedRoute';
import { AuthCallbackPage } from './pages/AuthCallbackPage';
import { LoginPage } from './pages/LoginPage';
import { FamilyPage } from './pages/Family';
import { EventsPage } from './pages/Events';
import { CheckInResultPage } from './pages/CheckInResult';
import { CheckInConfirmation } from './pages/CheckInConfirmation';
import { PastEventsPage } from './pages/PastEvents';
import { UpcomingEventsPage } from './pages/UpcomingEvents';
import { MyFamiliesPage } from './pages/MyFamilies';
import { RegistrationPage } from './pages/RegistrationPage';
import { PhotoReleasePage } from './pages/PhotoReleasePage';
import { useServiceWorkerUpdate } from './hooks/useServiceWorkerUpdate';
import './App.css';

function App() {
  // Handle service worker updates with toast notifications
  useServiceWorkerUpdate();

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route
          path="/family/:id"
          element={
            <ProtectedRoute>
              <FamilyPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events"
          element={
            <ProtectedRoute>
              <EventsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/check-in-confirmation"
          element={
            <ProtectedRoute>
              <CheckInConfirmation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/check-in-result"
          element={
            <ProtectedRoute>
              <CheckInResultPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-events"
          element={
            <ProtectedRoute>
              <PastEventsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/upcoming"
          element={
            <ProtectedRoute>
              <UpcomingEventsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-families"
          element={
            <ProtectedRoute>
              <MyFamiliesPage />
            </ProtectedRoute>
          }
        />
        <Route path="/register" element={<RegistrationPage />} />
        <Route path="/photo-release" element={<PhotoReleasePage />} />
        <Route path="/" element={<Navigate to="/my-families" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
